var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "post-info-section" }, [
    _c("div", { staticClass: "details" }, [
      _c("span", { staticClass: "campaign-title" }, [
        _vm._v("Series name goes here")
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.deliverableDetail.title))]),
      _vm._v(" "),
      _c("hr")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }